import React, { Component } from "react";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import imgError from "../../img/error/hiError.gif"

class ErrorCatch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        }
        this.onHideErrorDialog = this.onHideErrorDialog.bind(this);
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true});
        if (errorInfo) {
            console.log("Error: " + errorInfo.componentStack)
        }
    }
    onHideErrorDialog() {
        this.setState({
            hasError: false,
        });
        this.props.history.push({
            pathname: '/app/',
        });
    }
    render() {
        const { children } = this.props;
        const { hasError } = this.state;
        if (hasError) {
            let dialogHeader =
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-8 p-lg-10" style={{padding: '.1em'}}>
                        <h1 className={"nunito"}>Oops!</h1>
                    </div>
                    <div className="p-col-12 p-md-4 p-lg-2" style={{padding: '.3em'}}>
                        <Button label="Home" onClick={this.onHideErrorDialog}
                        />
                    </div>
                </div>;
            return (
                <React.Fragment>
                    <Dialog visible={hasError} header={dialogHeader} modal={true}
                            onHide={this.onHideErrorDialog} closable={false}
                            style={{width: "45%",}}>
                        <div align={'center'}>
                            <img alt="lightBulb" src={imgError} style={{maxWidth: "100%", maxHeight: "100%",}}/>
                            <br/>
                            <h2 className={"secondary-text"}>{"Algo raro sucedió, no te preocupes ya lo estamos revisando. Inténtalo más tarde."}</h2>
                        </div>
                    </Dialog>
                </React.Fragment>
            )
        }
        return children
    }
}

export default ErrorCatch;

